import { Dropdown, Menu } from "antd";
import { Button } from "components/Button/Button";
import { Icon } from "components/Icon/Icon";
import { actions as pluginActionActions } from "components/PluginsPopover/Plugin.reducer";
import PropTypes from "prop-types";
import { Fragment } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getRelativeUrl } from "utils/service";

const PluginListAction = ({
    parentAction,
    childActions,
    resourceIds,
    isSingularAction,
    beforeAction,
    afterAction,
    isDeleted,
    isNewRecord,
}) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const data = isSingularAction ? { id: resourceIds[0] } : { ids: resourceIds };

    const onClick = (action) => {
        beforeAction().then(() =>
            new Promise((resolve, reject) => {
                dispatch({
                    type: pluginActionActions.CALL_PLUGIN_ACTION,
                    promise: { resolve, reject },
                    pluginAction: action,
                    data,
                });
            })
                .then((execution_id) => {
                    history.push(getRelativeUrl("execution", execution_id));
                })
                .catch((error) => error)
                .finally(() => {
                    afterAction();
                })
        );
    };

    const childrenPopover =
        childActions.length === 0 ? (
            <Fragment />
        ) : (
            <Menu>
                {childActions.map((childAction) => (
                    <Menu.Item
                        key={`childAction ${childAction.id}`}
                        icon={childAction?.icon ? <Icon byName={childAction.icon} /> : null}
                        onClick={() => onClick(childAction)}
                        disabled={isDeleted}
                    >
                        {childAction.name}
                    </Menu.Item>
                ))}
            </Menu>
        );

    const component =
        // eslint-disable-next-line no-nested-ternary
        childActions.length === 0 ? (
            <Button
                image={parentAction?.icon ? <Icon byName={parentAction.icon} /> : null}
                label={parentAction?.name}
                variation="dark"
                onClick={() => onClick(parentAction)}
                disabled={isNewRecord || isDeleted}
                className="pluginActionButton"
                key={`action ${parentAction.id}`}
            />
        ) : parentAction.flow_id ? (
            <Dropdown.Button
                className={`pluginActionDropdownButton ${isNewRecord ? "button--disabled" : ""}`}
                onClick={() => onClick(parentAction)}
                overlay={childrenPopover}
                key={`action ${parentAction.id}`}
                disabled={isNewRecord}
            >
                {parentAction?.icon ? <Icon byName={parentAction.icon} /> : null}
                {parentAction?.name}
            </Dropdown.Button>
        ) : (
            <Dropdown
                overlay={childrenPopover}
                trigger={["click"]}
                key={`action ${parentAction.id}`}
            >
                <Button
                    label={parentAction?.name}
                    image={parentAction?.icon ? <Icon byName={parentAction.icon} /> : null}
                    variation="dark"
                    disabled={isDeleted || isNewRecord}
                    className="pluginActionButton"
                />
            </Dropdown>
        );

    return component;
};
PluginListAction.defaultProps = {
    beforeAction: () => Promise.resolve(),
};
PluginListAction.propTypes = {
    parentAction: PropTypes.shape().isRequired,
    childActions: PropTypes.arrayOf(PropTypes.object).isRequired,
    resourceIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    isSingularAction: PropTypes.bool.isRequired,
    beforeAction: PropTypes.func.isRequired,
    afterAction: PropTypes.func.isRequired,
    isDeleted: PropTypes.bool,
    isNewRecord: PropTypes.bool,
};

export default PluginListAction;
